import React, { useState, useEffect } from "react";
import { StyleSheet, css } from 'aphrodite';

import image1 from "../../assets/site-cav_7.png";
import image2 from "../../assets/site-cav_2.png";
import image3 from "../../assets/site-cav_6.jpg";
import { Flex, Image } from "@chakra-ui/react";

const images = [image1, image2, image3 /* Add more imported images here */];


function MobileCarousel() {
  const [currentImage, setCurrentImage] = useState(images.length - 1);;
  const [transitioning, setTransitioning] = useState(false);

  const nextSlide = () => {
    if (!transitioning) {
      setTransitioning(true);
      setTimeout(() => {
        setCurrentImage((prevImage) =>
          prevImage === images.length - 1 ? 0 : prevImage + 1
        );
        setTransitioning(false);
      }, 500); // Adjust the transition duration (in milliseconds)
    }
  };

  useEffect(() => {
    const interval = setInterval(nextSlide, 3000); // Change image every 2 seconds
    return () => clearInterval(interval); // Cleanup on unmount
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex className={css(styles.carousal)}>
        <Flex className={css(styles.slideContainer)}>
        {images.map((_, index) => (
            <Flex
                key={index}
                className={css(styles.slide, currentImage === index && styles.currentSlide, transitioning && styles.slideTransition)}
                onClick={() => setCurrentImage(index)}
            >
                <Image
                src={images[currentImage]}
                alt={`Slide ${currentImage + 1}`}
                style={{
                    justifyContent: 'center',
                    objectFit: 'cover',
                    width: '90%',
                    maxHeight: '40%'
                }}
                />
            </Flex>
            ))}
      </Flex>
    </Flex>
  );
}

const styles = StyleSheet.create({
    carousal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '30vh',
        width: '100vw',
        overflow: 'hidden',
        position: 'relative',
        marginTop:'120px'
    },
    slideContainer: {
        display: "flex",
        transition: "transform 0.8s ease", // CSS transition for sliding effect
        alignContent: 'center',
        justifyContent: 'center',
        minWidth: '100vw',
      },
      slide: {
        flex: "0 0 100%",
        alignContent: 'center',
        justifyContent: 'center',
        height: '100%'
    },
    imageStyle: {
        alignContent: 'center',
    },
    currentSlide: {
        transform: "translateX(0%)", // Start from the right-most image
      },
      slideTransition: {
        transform: "translateX(-100%)", // Slide transition effect
      },
})

export default MobileCarousel;
